import BaseComponent from "../components/BaseComponent";
import {Panel, SplitCol, SplitLayout, View} from "@vkontakte/vkui";
import React from "react";
import {AdaptivityContext} from "../assets/constants";
import StaffList from "../references/staff/List";
import StaffForm from "../references/staff/Form";
import {OfflineProvider} from "../contexts/OfflineContext";

class FragmentStaff extends BaseComponent {
    constructor(props) {
        super(props);
        const state = {
            activePanelStaff: "panel_staff_list",
            current_staff: null,
            listState: null,
        };

        this.state = {
            ...this.state,
            ...state
        };
    }

    saveListState = (listState) => {
        this.setState({listState});
    }

    editCurrentStaff = (e, fieldName) => {
        const {current_staff} = this.state;
        if (!current_staff) {
            return;
        }

        if (e && e.sale_point_id !== undefined) {
            this.setState({
                current_staff: {
                    ...current_staff,
                    ...e
                }
            });
            return;
        }

        if (fieldName === 'birth_date') {
            const value = e.currentTarget.value;
            current_staff.birth_date = value ? value : null;
        } else if (fieldName === 'is_owner' || fieldName === 'is_lpr') {
            current_staff[fieldName] = e.currentTarget.checked ? 1 : 0;
        } else if (fieldName === 'position_id' || fieldName === 'qualification') {
            current_staff[fieldName] = e.currentTarget.value ? Number(e.currentTarget.value) : 0;
        } else {
            current_staff[fieldName] = e.currentTarget.value;
        }
        this.setState({current_staff});
    }

    receiveMessage = (event) => {
        if (event.data && event.data.type === 'reloadCurrentList') {
            this.setState({listState: null});
        }
        if (event.data.type !== undefined && event.data.type === 'setCurrentStaff') {
            if (!event.data.value) {
                this.setState({
                    current_staff: null,
                    activePanelStaff: 'panel_staff_list',
                    listState: null
                });
                return;
            }
            this.setState({
                current_staff: event.data.value,
                activePanelStaff: 'panel_staff_item'
            });
        }
    }

    render() {
        return <OfflineProvider>
            <View activePanel={this.state.activePanelStaff} id="staff_story">
            <Panel id="panel_staff_list">
                <SplitLayout>
                    {AdaptivityContext.isMobile ? '' : this.MainMenu()}
                    <SplitCol>
                        <StaffList
                            current_user={this.props.current_user}
                            base_url={this.state.base_url}
                            savedListState={this.state.listState}
                            onSaveListState={this.saveListState}
                        />
                    </SplitCol>
                </SplitLayout>
            </Panel>
            <Panel id="panel_staff_item">
                <SplitLayout>
                    {AdaptivityContext.isMobile ? '' : this.MainMenu()}
                    <SplitCol>
                        <StaffForm
                            key={this.state.current_staff && this.state.current_staff.id}
                            current_user={this.props.current_user}
                            base_url={this.props.base_url || this.state.base_url}
                            item={this.state.current_staff}
                            change={this.editCurrentStaff}
                            hideForm={() => this.setState({
                                current_staff: null,
                                activePanelStaff: 'panel_staff_list',
                                listState: null
                            })}
                        />
                    </SplitCol>
                </SplitLayout>
            </Panel>
        </View>
        </OfflineProvider>;
    }
}

export default FragmentStaff;
